<template lang="html">
    <section class="edit-count-down countdown-edit">
        <b-container fluid>
            <div class="countdown-error" v-if="errorMsg[getCurrentLang()] && action.errorMsg"><span>*</span> {{ errorMsg[getCurrentLang()] }}</div>
            <b-form class="countdown-form" @submit.prevent="updateThisCountDown(action);" novalidate>
                <b-row v-for="type in types" :class="'countdown-input m-' + type.name" :key="type.name">
                    <b-col>
                        <b-form-group :label="type.label[getCurrentLang()]" label-class="label-form" :label-for="type.name"></b-form-group>
                        <b-form-input
                            v-model="action.formData[type.name]"
                            v-validate="type.required"
                            :id="type.name"
                            :type="type.type"
                            :placeholder="type.placeholder"
                        ></b-form-input>
                    </b-col>
                </b-row>

                <div class="row countdown-input m-standDesignList">
                    <label class="label-stand">{{ $t("countdown.colstanddesign") }}</label>
                    <div class="clearfix"></div>
                    <select :disabled="standDesignList.length === 0" v-model="action.formData.standDesign.id" class="selectStandDesign uppercase">
                        <option
                            v-for="(city_obj, city) in standDesignList"
                            :key="city"
                            v-bind:selected="action.formData.standDesign.id === city_obj.id"
                            v-bind:value="city_obj.id"
                        >
                            {{ city_obj.name }}
                        </option>
                    </select>
                </div>

                <div class="countdown-textarea">
                    <div class="btnAddDesc" style="text-align: left;">
                        <span @click="showAddDesc();">{{ $t("countdown.adddesc") }}</span>
                    </div>

                    <div v-if="showDesc" v-for="(desc, key) in action.formData.terms.description" class="blocTextArea" :key="key">
                        <label
                            >{{ $t("countdown.adddesc") }} : <strong>{{ key }}</strong>
                        </label>
                        <div class="clearfix"></div>
                        <textarea class="textArea" v-model.trim="desc.value" :id="key" :name="desc.value" :key="key" rows="4" cols="40"></textarea>
                    </div>
                </div>

                <div class="countdown-action">
                    <b-button type="submit">{{ $t("countdown.btncreate") }}</b-button>
                    <b-button @click="onResetUpdate();">{{ $t("countdown.btncancel") }}</b-button>
                </div>
            </b-form>
        </b-container>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
import httpService from '../../../../components/service'
import connectionBO from '../../../../services/connectionBO'
import Globals from '../../../../components/globals'
import cacheService from "@/services/cache";

export default {
    name: 'edit-count-down',
    props: [
        'action'
    ],
    data () {
        return {
            errorMsg: '',
            selected: null,
            standDefault: null,
            standDesignList: {},
            descriptionArea: null,
            showDesc: false,
            getLangsValue: [],
            formData: {
                name: '',
                dateStart: '',
                timeStart: '',
                dateEnd: '',
                timeEnd: '',
                standDesign: '',
                desc: ''
            },
            types: [
                {
                    name: 'name',
                    type: 'text',
                    placeholder: 'Name',
                    required: 'required',
                    label: {
                        en: 'Name',
                        fr: 'Nom'
                    }
                },
                {
                    name: 'dateStart',
                    type: 'date',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'Start date',
                        fr: 'Date début'
                    }
                },
                {
                    name: 'timeStart',
                    type: 'time',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'Start time',
                        fr: 'Heure début'
                    }
                },
                {
                    name: 'dateEnd',
                    type: 'date',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'End date',
                        fr: 'Date fin'
                    }
                },
                {
                    name: 'timeEnd',
                    type: 'time',
                    placeholder: '',
                    required: 'required',
                    label: {
                        en: 'End time',
                        fr: 'Heure fin'
                    }
                }
            ]
        }
    },
    watch: {
    },
    created () {
        this.listCountDown()
        httpService.get('/admin/standDesigns/list')
            .then((response) => {
                this.standDesignList = response.data
            })
        this.getLangsValue = this.getLangs.map(v => {
            return {
                'label': v.label,
                'value': ''
            }
        })
    },
    methods: {
        ...mapActions({
            listCountDown: 'countdown/listCountDown'
        }),
        getCurrentLang () {
            return cacheService.getUserLang()
        },
        showAddDesc () {
            this.showDesc = !this.showDesc
        },
        onResetUpdate () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        },
        updateThisCountDown (value) {
            let dateStart = new Date(this.action.formData.dateStart + ' ' + this.action.formData.timeStart + ':00')
            let dateEnd = new Date(this.action.formData.dateEnd + ' ' + this.action.formData.timeEnd + ':00')

            let newCountdown = {
                name: this.action.formData.name,
                startDate: (this.action.formData.dateStart && this.action.formData.timeStart)
                    ? Globals.transformDateToGmt(dateStart)
                    : '',
                endDate: (this.action.formData.dateEnd && this.action.formData.timeEnd)
                    ? Globals.transformDateToGmt(dateEnd)
                    : '',
                standDesign: {
                    id: this.action.formData.standDesign.id
                },
                translations: Object.values(value.formData.terms.description).map((v, key) => {
                    return {
                        'id': v.id,
                        'field': 'description',
                        'content': v.value
                    }
                })
            }
            if (newCountdown.name && newCountdown.startDate && newCountdown.endDate && newCountdown.standDesign.id) {
                if (dateStart.getTime() >= dateEnd.getTime()) {
                    this.action.errorMsg = true
                    this.errorMsg = {
                        en: 'End date must be greater than start date',
                        fr: 'La date de fin doit être supérieure àla date de début'
                    }
                } else {
                    connectionBO.putCountDown(this.action.data.id, newCountdown).then(response => {
                        if (response === 'success') {
                            this.listCountDown()
                            this.action.errorMsg = true
                            this.errorMsg = {
                                en: 'Countdown successfully modified',
                                fr: 'La période-promo a bien été modifié'
                            }
                        } else {
                            this.action.errorMsg = true
                            if (response.message === "countdown_name_duplicated") {
                                this.errorMsg = {
                                    en: 'A countdown with this name already exists',
                                    fr: 'Une période-promo avec ce nom existe déja'
                                }
                            } else {
                                this.errorMsg = {
                                    en: 'Error. Please contact application Support',
                                    fr: "Erreur. Veuillez contacter l'assistance "
                                }
                                console.error('...+ ERROR DeleteCountDown +....', response)
                            }

                        }
                    })
                }
            } else {
                this.action.errorMsg = true
                this.errorMsg = {
                    en: 'All fields are required',
                    fr: 'Tous les champs sont obligatoires'
                }
            }
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {
        ...mapGetters({
            getCountDown: 'countdown/getCountDown',
            getLangs: 'i18n/getLangs'
        })
    }
}
</script>

<style scoped lang="scss">
.edit-count-down {
    & .countdown {
        &-error {
            color: red;
            margin-bottom: 10px;
            & span {
                color: red;
            }
        }
        &-textarea {
            margin: 20px 15px;
            text-align: left;
            & .blocTextArea {
            }
            & .btnAddDesc {
                text-align: left;
                border-bottom: 1px dotted black;
                padding-bottom: 5px;
                margin-bottom: 10px;
                & span {
                    font-size: 13px;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                    &:after {
                        content: "›";
                        display: inline-block;
                        margin-left: 5px;
                        font-size: 18px;
                    }
                }
            }
            & .blocTextArea {
                display: inline-block;
                & label {
                    color: black;
                    margin-bottom: 10px;
                    font-size: 12px;
                    font-weight: normal;
                    display: block;
                }
                &:nth-child(2n) {
                    margin-right: 30px;
                }
            }
        }
        &-form {
            & input {
                border: 1px solid black;
                background: white;
                padding: 15px 5px;
                font-size: 13px;
                &[type="text"] {
                    padding: 18px 5px;
                }
            }
            & select {
                background: white;
                padding: 15px 5px;
                border: 1px solid black;
            }
        }
        &-input {
            display: inline-block;
            position: relative;
            &:nth-child(1) {
                /*margin-right: 10px;*/
            }
            &:nth-child(3) {
                margin-right: 10px;
                left: -1px;
            }
            &:nth-child(5) {
                left: -1px;
            }
            &:nth-child(6) {
                margin-left: 7px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditCountDown.vue?d17b0736